<template>
  <div :class="['alert', 'snappy-alert', `alert-${notification.status}`, {'alert-dismissible': notification.dismissible}]" role="alert">
    <button
      type="button"
      class="close snappy-alert__close"
      data-dismiss="alert"
      aria-label="Close"
      @click="$emit('close')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div v-html="notification.message"></div>
  </div>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.snappy-alert {
  text-align: left;
  &__close {
    background: transparent;
  }
}
</style>